import React from 'react';

import { Heading, Text, className, Spinner } from 'aplazame-design-system';
import { useTranslate } from 'soluble-gatsby-source';

import HubspotForm from '../HubspotForm';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';

function FormSpinner() {
    return (
        <div
            {...className(
                `${style.loader} d-flex justify-content-center align-items-center`
            )}
        >
            <Spinner size="2.5rem" color="primary" borderSmall={false} />
        </div>
    );
}

export default function NewsletterHubspotForm({
    hubspotFormId,
    hubspotPortalId,
}) {
    const translation = useTranslate();

    return (
        <div
            {...className(
                `${style.wrapper} pt-8 pl-6 pr-6 pl-lg-5 pr-lg-5 pb-5 ${colorStyle['bg--quaternary']} d-flex flex-column justify-content-between`
            )}
        >
            <div>
                <Heading tag="h3" className={`mb-3 ${style.heading}`}>
                    {
                        translation[
                            'wordpress-posts-section.newsletter-item.title'
                        ].text
                    }
                </Heading>
                <Text
                    tag="div"
                    className={`body mb-5 ${style.text} ${transitionStyle['child-link']}`}
                >
                    {
                        translation[
                            'wordpress-posts-section.newsletter-item.text'
                        ].md
                    }
                </Text>
            </div>
            <div className={style.form}>
                {typeof window !== 'undefined' &&
                hubspotFormId &&
                hubspotPortalId ? (
                    <HubspotForm
                        portalId={hubspotPortalId}
                        formId={hubspotFormId}
                        loading={<FormSpinner />}
                    />
                ) : (
                    <FormSpinner />
                )}
            </div>
        </div>
    );
}
